/* eslint-disable camelcase */
import React, { useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';

const useStyles = makeStyles(() => ({
  filterRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '1rem',
  },
  textField: {
    maxWidth: 230,
  },
  button: {
    marginLeft: '2rem',
    color: 'white',
    backgroundColor: '#00d1b2',
    '&:hover': {
      backgroundColor: '#00bca0',
    },
  },
}));

const NotificationLogFilterPanel = ({ onChange }) => {
  const classes = useStyles();
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const handleStartChange = (event) => {
    setStartDate(event.target.value);
    onChange({ start: event.target.value, end: endDate})
  };

  const handleEndChange = (event) => {
    setEndDate(event.target.value);
    onChange({ start: startDate, end: event.target.value})
  };

  return (
    <div className={classes.filterRow}>
      <p>
        <b>Filters:</b>
      </p>
      <TextField
        id="date1"
        label="Start"
        type="date"
        className={classes.textField}
        variant="outlined"
        size="small"
        value={startDate}
        onChange={handleStartChange}
        InputLabelProps={{
          shrink: true,
        }}
      />
      <TextField
        id="date2"
        label="End"
        type="date"
        variant="outlined"
        size="small"
        value={endDate}
        onChange={handleEndChange}
        className={classes.textField}
        InputLabelProps={{
          shrink: true,
        }}
      />
    </div>
  );
};

NotificationLogFilterPanel.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default NotificationLogFilterPanel;
